import {PricingPrice} from "./PricingPrice";

export class PricingMoney {
    private readonly price: PricingPrice;
    private readonly language: string;

    public constructor(price: PricingPrice, language: string) {
        this.price = price;
        this.language = language.replace('_', '-');
    }

    public toString() {
        return this.format( null, false, true );
    }

    public format(centsHtmlTag: string = 'sub', spaceBetweenSymbolAndAmount: boolean = false, withSymbol: boolean = true ): string {
        const localCurrency: LocalizedCurrency = this.getLocalizedCurrency();
        const optionalSpace = spaceBetweenSymbolAndAmount ? ' ' : '';

        let price = localCurrency.base;
        if (localCurrency.fraction !== '00') {
            price += (centsHtmlTag ? `<${centsHtmlTag}>` : '') + localCurrency.decimalSeparator + localCurrency.fraction + (centsHtmlTag ? `</${centsHtmlTag}>` : '');
        }

        const localCurrencySymbol = withSymbol ? localCurrency.symbol : '';
        if (localCurrency.symbolLocation === 'begin') {
            return localCurrencySymbol + optionalSpace + price;
        }
        return price + optionalSpace + localCurrencySymbol;
    }

    private getLocalizedCurrency(): LocalizedCurrency {
        let intl: Intl.NumberFormat = new Intl.NumberFormat(
            this.language,
            {
                'style': 'currency',
                'currency': this.price.currency,
                'maximumFractionDigits': 2,
                'minimumFractionDigits': 2
            }
        );
        return new LocalizedCurrency(intl.formatToParts(this.price.amount));
    }
}

class LocalizedCurrency {
    public readonly symbol: string;
    public readonly symbolLocation: string;
    public readonly decimalSeparator: string;
    public readonly base: string = '';
    public readonly fraction: string = '00';

    public constructor(parts: Array<any>) {
        for (let i: number = 0; i < parts.length; i++) {
            let val = parts[i].value;
            switch (parts[i].type) {
                case 'currency':
                    this.symbolLocation = (i === 0) ? 'begin' : 'end';
                    this.symbol = val;
                    break;
                case 'integer':
                case 'group':
                    this.base += val;
                    break;
                case 'decimal':
                    this.decimalSeparator = val;
                    break;
                case 'fraction':
                    this.fraction = val;
                    break;
            }
        }
    }
}